import styled from 'styled-components';

import {getRem, ms} from '../../../../../../styles';
import {Text} from '../../../../../../uikit/Text';
import {View} from '../../../../../../uikit/View';

export const Container = styled(View)`
  flex-direction: column;
  gap: ${ms(12)};
`;

export const Title = styled(Text).attrs({weight: 'semibold'})`
  font-size: ${getRem(16)};
`;
